import { useCallback, useState } from "react"

import { useParams } from "react-router-dom"

import { CatalogItemEditModal, useGetViewCenter } from "@l2r-front/l2r-common"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { VerticalSignPoleAddFormPost } from "../../forms/VerticalSignPoleAddForm/VerticalSignPoleAddForm.post"

import * as Styled from "./VerticalSignsSidebarComponents.styled"

export function VerticalSignsSidebarComponents(props) {

    const {
        handleChangeTypeFilter,
    } = props

    const [mapLocation, setMapLocation] = useState(null)

    const { t } = useTranslation(I18N_NAMESPACE)
    const isMobile = useIsMobileDevice()
    const { code, road } = useParams()
    const getViewCenter = useGetViewCenter()

    const handleCreatePole = useCallback(() => {
        setMapLocation(getViewCenter())
    }, [getViewCenter, setMapLocation])

    const handleCloseModal = useCallback(() => {
        setMapLocation(null)
    }, [])

    return <Styled.Container>
        {road && <Styled.RoadDetailInfo isMobile={isMobile} road={road} />}
        <Styled.VerticalSignsGrading road={road} isMobile={isMobile} />
        <Styled.VerticalSignTypeList
            baseVerticalSignTypeCode={code}
            isMobile={isMobile}
            onChangeFilter={handleChangeTypeFilter}
            onCreate={handleCreatePole}
        />
        {
            mapLocation &&
            <CatalogItemEditModal
                formTitle={t(I18N_NAMESPACE, "containers.verticalSignPoleAddForm.title")}
                typeTitle={t(I18N_NAMESPACE, "containers.verticalSignDetailsForm.type")}
                contentFieldLabel={t(I18N_NAMESPACE, "containers.verticalSignDetailsForm.content")}
                FormComponent={VerticalSignPoleAddFormPost}
                startingPosition={mapLocation}
                open={!!mapLocation}
                onClose={handleCloseModal}
            />
        }
    </Styled.Container>
}

VerticalSignsSidebarComponents.propTypes = {
    handleChangeTypeFilter: PropTypes.func,
    toggleFilter: PropTypes.func,
}